import { useState, useEffect } from "react";
import { useParams, Switch, Route } from "react-router-dom";

import { API_URL, scroll, getValFromLS, consoilidatedGuests } from "../helpers";

import Hdg from "../components/Hdg";
import Notice from "../components/Notice";
import Alert from "../components/Alert";

import Table2 from "./Table2";
import StatusesGolf from "./StatusesGolf";
import Form from "./Form";
import Form2 from "./Form2";

import StatusesNav from "./StatusesNav";
import Nav from "./Nav";

const Statuses = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [notice, setNotice] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const { str } = useParams();

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardStatusesInit`);
			const params = {
				q: auth.id ? auth.id : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });
					setDetails({ ...json });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleSuccess = (text) => {
		scroll();
		setNotice({ type: "success", text });
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="View All Guests" />

						<StatusesNav selected={!str ? "snapshot" : str} />

						{notice.type && <Notice data={notice} />}

						<Switch>
							<Route exact path="/dashboard/statuses">
								<p>
									Please see below for all of your current guests’ statuses for
									each event.
								</p>

								<p>
									Click a name to view additional details, resend a pending
									invitation, or remove a guest from an event. To remove a
									guest, click on your guest’s name, and then click the trash
									can icon ( <i className="fa fa-trash error fa-lg" /> ) under
									the remove column. This will allow you to enter in a new guest
									to fill their spot.
								</p>

								<p>
									Please note that removing the guest from the event will
									trigger an automatic email notification to your guest.
								</p>

								<Table2
									data={consoilidatedGuests(
										details.golf.guests,
										details.sporting.guests,
										details.welcome.guests,
										details.gift.guests,
									)}
								/>
							</Route>
							<Route exact path="/dashboard/statuses/golf">
								<p>
									Use this page to assign your golf groups to a preferred course
									and your participants to a group number under your allotment.
									Our team will do our best to accommodate.
								</p>
								<StatusesGolf success={handleSuccess} data={details.golf} />
							</Route>
							<Route exact path="/dashboard/statuses/sporting">
								<p>
									Use this page to assign your sporting clays participants to a
									group number under your allotment.
								</p>
								<Form success={handleSuccess} data={details.sporting} />
							</Route>
							<Route exact path="/dashboard/statuses/welcome">
								<p>
									Current statuses for welcome party guests. Click a name to
									view additional details, remove from an event or resend a
									pending invitation.
								</p>
								<Form2 data={details.welcome} />
							</Route>
							<Route exact path="/dashboard/statuses/gift">
								<p>
									Current statuses for gift package recipients. Click a name to
									view additional details, remove from an event or resend a
									pending invitation.
								</p>
								<Form2 data={details.gift} />
							</Route>
						</Switch>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={3} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Statuses;
